import React, { useState } from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Box, FormControlLabel, Checkbox, IconButton, Tooltip as MuiTooltip, Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend, ChartDataLabels);

const EntregasATiempoBar = ({ selectedIndustries = [], onBarClick = () => {} }) => {
  const [infoOpen, setInfoOpen] = useState(false);

  const allLabels = [
    'Manufactura',
    'Salud/Farmacéutica',
    'Retail',
    'Servicios logísticos',
    'Alimentos',
    'Construcción',
    'Automotriz',
  ];

  const deliveryData2023 = {
    'Manufactura': 96,
    'Salud/Farmacéutica': 96,
    'Retail': 94,
    'Servicios logísticos': 92,
    'Alimentos': 91,
    'Construcción': 89,
    'Automotriz': 88,
  };

  const deliveryData2024 = {
    'Manufactura': 95,
    'Salud/Farmacéutica': 100,
    'Retail': 92,
    'Servicios logísticos': 96,
    'Alimentos': 96,
    'Construcción': 93,
    'Automotriz': 89,
  };

  const colorMap = {
    '2022': '#4B73B1',
    '2023': '#A2AEBB',
  };

  const labels = selectedIndustries.length > 0 ? selectedIndustries : allLabels;
  const dataValues2023 = labels.map((label) => deliveryData2023[label]);
  const dataValues2024 = labels.map((label) => deliveryData2024[label]);

  const chartData = {
    labels: labels,
    datasets: [
      {
        label: 'Entregas a tiempo (2022)',
        data: dataValues2023,
        backgroundColor: colorMap['2022'],
        borderColor: '#fff',
        borderWidth: 2,
      },
      {
        label: 'Entregas a tiempo (2023)',
        data: dataValues2024,
        backgroundColor: colorMap['2023'],
        borderColor: '#fff',
        borderWidth: 2,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: 'y',
    plugins: {
      legend: {
        display: true,
        position: 'top',
      },
      tooltip: {
        callbacks: {
          label: (context) => `${context.raw}%`,
        },
      },
      datalabels: {
        color: '#000',
        font: { weight: 'bold', size: 14 },
        anchor: 'end',
        align: 'right',
        offset: -2,
        formatter: (value) => `${value}%`,
        clip: false,
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        max: 110,
        ticks: {
          stepSize: 10,
        },
        title: {
          display: true,
          text: 'Porcentaje (%)',
        },
      },
      y: {
        ticks: {
          font: { size: 14 },
        },
      },
    },
    onClick: (evt, elements) => {
      if (elements.length > 0) {
        const index = elements[0].index;
        const industry = chartData.labels[index];
        handleSegmentClick(industry);
      }
    },
  };

  const handleSegmentClick = (industry) => {
    let updatedSelectedIndustries = [...selectedIndustries];
    if (updatedSelectedIndustries.includes(industry)) {
      updatedSelectedIndustries = updatedSelectedIndustries.filter((item) => item !== industry);
    } else {
      updatedSelectedIndustries.push(industry);
    }
    onBarClick(updatedSelectedIndustries);
  };

  const handleCheckboxChange = (industry) => {
    handleSegmentClick(industry);
  };

  const infoContent = {
    Analisis: 'La gráfica presenta el desempeño de las industrias en cuanto a las entregas a tiempo al cliente durante 2022 y 2023. Destacan los avances en sectores como Salud/Farmacéuticas, Alimentos y Servicios logísticos, consolidando su compromiso con la puntualidad y confiabilidad en la última milla. Este indicador refleja una mejora sostenida en la gestión del transporte, clave para fortalecer la experiencia del cliente y la eficiencia operativa.',
    formula: 'Entregas a Tiempo (%) = (Número de entregas a tiempo / Número total de entregas) × 100',
    description: 'Esta gráfica muestra el porcentaje de entregas realizadas dentro del tiempo establecido para diversos sectores industriales en los años 2022 y 2023. Este indicador mide la puntualidad y eficiencia en la cadena de suministro.'  };
  

  return (
    <div style={{ maxWidth: '600px', height: '555px', margin: '0 auto' }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <MuiTooltip title="Información de la gráfica">
          <IconButton onClick={() => setInfoOpen(true)}>
            <InfoIcon />
          </IconButton>
        </MuiTooltip>
      </Box>
      <Box display="flex" justifyContent="center" flexWrap="wrap" mb={2}>
        {allLabels.map((industry) => (
          <FormControlLabel
            key={industry}
            control={
              <Checkbox
                checked={selectedIndustries.includes(industry)}
                onChange={() => handleCheckboxChange(industry)}
                color="primary"
              />
            }
            label={industry}
          />
        ))}
      </Box>
      <div style={{ width: '100%', height: '420px' }}>
        <Bar data={chartData} options={options} />
      </div>
  
      <Dialog open={infoOpen} onClose={() => setInfoOpen(false)}>
        <DialogTitle>Información de la Gráfica</DialogTitle>
        <DialogContent>
        <p><strong>Análisis:</strong> {infoContent.Analisis}</p>
          <p><strong>Fórmula:</strong> {infoContent.formula}</p>
          <p><strong>Descripción:</strong> {infoContent.description}</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setInfoOpen(false)} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
  
};

export default EntregasATiempoBar;
